import { render } from "./ClientRemindersChip.vue?vue&type=template&id=06b01c0a"
import script from "./ClientRemindersChip.vue?vue&type=script&lang=js"
export * from "./ClientRemindersChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__